export default "__VITE_ASSET__CwnINoRf__"